export const SET_DISPLAY_MODE = 'SET_DISPLAY_MODE';



// WEBPACK FOOTER //
// ./js/actions/SetDisplayMode.js